export default "__VITE_ASSET__1f32c267__"